/**
 * Типы сообщений
 * @type {Object}
 */
export var MESSAGE_TYPE = {
  text: 'text',
  rich: 'rich',
  suggest: 'suggest',
  listening: 'listening',
  command: 'command'
};

/**
 * От кого было сообщение
 * @type {Object}
 */
export var MESSAGE_FROM = {
  assistant: 'assistant',
  user: 'user'
};

/**
 * Типы директив ответы помощника
 * @type {Object}
 */
export var DIRECTIVE_TYPES = {
  clientAction: 'client_action',
  serverAction: 'server_action'
};

/**
 * Названия директив
 * @type {Object}
 */
export var DIRECTIVE_NAMES = {
  openUri: 'open_uri',
  type: 'type',
  typeSilent: 'type_silent',
  onSuggest: 'on_suggest',
  onExternalButton: 'on_external_button',
  openDialog: 'open_dialog',
  updateDialogInfo: 'update_dialog_info',
  endDialogSession: 'end_dialog_session',
  newDialogSession: 'new_dialog_session'
};

/**
 * Типы карточек
 * @type {Object}
 */
export var CARD_TYPES = {
  text: 'simple_text',
  textWithButton: 'text_with_button',
  div: 'div_card'
};

/**
 * Типы саджестов
 * @type {Object}
 */
export var SUGGEST_TYPES = {
  feedbackNegative: 'feedback__negative',
  feedbackPositive: 'feedback__positive'
};

/**
 * Типы log_id
 * @type {Object}
 */
export var LOG_ID = {
  help: 'all_skills_footer'
};

/**
 * Типы экшенов карточек. Используются для
 * вызова нужного обработчика директивы
 * @type {Object}
 */
export var ACTION_TYPE = {
  uri: 'uri',
  dialog: 'dialog-action',
  div: 'div-action',
  button: 'button'
};

/**
 * Значение фактически означающие кол-во символов в строке.
 * Является примерным и служит для примерного расчета веса 
 * элемента карточки
 * @type {Number}
 */
export var LINE_SIZE = 20;

/**
 * Вес однострочного текстового сообщения
 * @type {Number}
 */
export var PRIMARY_WEIGHT = 1;

/**
 * Веса различных элементов, блоков и их содержимого
 * За единицу принимаем вес однострочного простого
 * сообщения.
 * @type {Object}
 */
export var WEIGHT = {
  textLine: PRIMARY_WEIGHT * 0.4,
  buttonLine: PRIMARY_WEIGHT * 0.8,
  button: PRIMARY_WEIGHT * 0.9,
  tabLineWeight: PRIMARY_WEIGHT * 0.7,
  traffic: PRIMARY_WEIGHT * 2.4,
  dateElement: PRIMARY_WEIGHT * 1.2,
  image: PRIMARY_WEIGHT * 1.5,
  cell: PRIMARY_WEIGHT * 0.8,
  bubble: 0.5
};